<div class="table-container">
  <table mdbTable class="z-depth-1">
    <thead>
      <tr>
        <th scope="col" [mdbTableSort]="data" sortBy="day">
          Day Of Week<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="number_of_days">
          # Days<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="units">
          Units<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="avg_price">
          Avg Price<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="subtotal">
          Sub Total<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="service_fees">
          Service Fees<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="tips">
          Tips<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="tip_percentage">
          Tip %<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="total">
          Total<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="redeemed">
          # Redeemed<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="redeemed_percentage">
          % Redeemed<mdb-icon fas icon="sort"></mdb-icon>
        </th>
        <th scope="col" [mdbTableSort]="data" sortBy="revenue_percentage">
          % Revenue<mdb-icon fas icon="sort"></mdb-icon>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of data">
        <td scope="row">{{ element.day }}</td>
        <td>{{ element.number_of_days }}</td>
        <td>{{ element.units }}</td>
        <td>{{ element.avg_price | currency }}</td>
        <td>{{ element.subtotal | currency }}</td>
        <td>{{ element.service_fees | currency }}</td>
        <td>{{ element.tips | currency }}</td>
        <td>{{ element.tip_percentage | percent }}</td>
        <td>{{ element.total | currency }}</td>
        <td>{{ element.redeemed }}</td>
        <td>{{ element.redeemed_percentage | percent }}</td>
        <td>{{ element.revenue_percentage | percent }}</td>
      </tr>
    </tbody>
    <tfoot class="">
      <tr class="totals-row">
        <td scope="row" class="left">TOTAL</td>
        <td>{{ tDays }}</td>
        <td>{{ tUnits }}</td>
        <td>{{ tAvgPrice | currency }}</td>
        <td>{{ tSubtotal | currency }}</td>
        <td>{{ tServiceFees | currency }}</td>
        <td>{{ tTips | currency }}</td>
        <td>{{ tTipPercentage | percent }}</td>
        <td>{{ tTotal | currency }}</td>
        <td>{{ tRedeemed }}</td>
        <td>{{ tRedeemedPercentage | percent }}</td>
        <td class="right">{{ tRevenue | percent }}</td>
      </tr>
    </tfoot>
  </table>
</div>
